export default "__VITE_ASSET__BReMgsLo__"